
'use client';

import { useEffect } from 'react';
import NextTopLoader, { useTopLoader } from 'nextjs-toploader';
import { NextIntlClientProvider } from 'next-intl';
import { useSearchParams } from 'next/navigation';

import { getMessageFallback } from './request';
import { usePathname } from './routing';

export function IntlWrapper(props) {
  return (
    <NextIntlClientProvider
      onError={() => {}}
      getMessageFallback={getMessageFallback}
      {...props}
    />
  );
}

export function LoaderWrapper({ children }) {
  const loader = useTopLoader();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    loader.done();
  }, [pathname, searchParams]);

  return (
    <>
      <NextTopLoader color="#2C8984" />
      {children}
    </>
  );
}
